"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIcon = require("@cdk-uip/react-icon");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * Used to render icons in a `<TextField>` component.
 */


var TextFieldIcon = function TextFieldIcon(_ref) {
  var className = _ref.className,
      tabIndex = _ref.tabIndex,
      onClick = _ref.onClick,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["className", "tabIndex", "onClick", "children"]);

  return _react2.default.createElement(_reactIcon.Icon, _extends({
    className: (0, _classnames2.default)("mdc-text-field__icon", className),
    onClick: onClick,
    tabIndex: tabIndex === undefined ? onClick ? "0" : undefined : tabIndex
  }, other), children);
};

TextFieldIcon.propTypes = {
  /** Click handler. Supply a function to make the icon clickable. */
  onClick: _propTypes.func
};
exports.default = TextFieldIcon;